import { createContext, useContext } from 'react';
import { CpsUser, Nullable, CpsIndex } from '@cs-cms/types';

interface ICurrentUserContext {
  currentUser?: Nullable<CpsUser>;
  isLoading?: boolean;
  selectedIndex?: CpsIndex;
  setSelectedIndex?: (selectedIndex: CpsIndex) => void;
}

export const CurrentUserContext = createContext<ICurrentUserContext>({
  currentUser: undefined
});

export const useCurrentUserContext = () => useContext(CurrentUserContext);
